export const LOCALSTORAGE_ID = `${process.env.REACT_APP_PACE_LOCAL_ID}`;
export const LOCALADMIN_DATA = `${process.env.REACT_APP_PACE_ADMIN_DATA}`;
export const LOCALCLIENT_DATA = `${process.env.REACT_APP_PACE_CLIENT_DATA}`;
export const LOCALSYSTEM_DATA = `${process.env.REACT_APP_PACE_SYSTEM_DATA}`;
export const LOCALADMIN_JWT = LOCALADMIN_DATA + `${process.env.REACT_APP_PACE_JWT}`;
export const LOCALCLIENT_JWT = LOCALCLIENT_DATA + `${process.env.REACT_APP_PACE_JWT}`;
export const LOCALSYSTEM_JWT = LOCALSYSTEM_DATA + `${process.env.REACT_APP_PACE_JWT}`;
export const REACT_PACE_KEY = `${process.env.REACT_APP_PACE_KEY}`;
